import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { AuthService } from '../../core/services/auth.service';
import { ClientService } from '../../core/services/client.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss'
})
export class NavBarComponent {


  ROUTE_DATA_TITLE = 'title';
  routeTitle = '';

  mfaLoading: boolean = true;
  isMfaEnforced: boolean | undefined;
  mfaEnabled: boolean | undefined;
  mfaReminderSupressed = false;
  clientMatterContactDetails: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private clientService: ClientService
  ) {
    clientService.getMfaReminderSupressed().subscribe(val => this.mfaReminderSupressed = val);
  }

  ngOnInit(): void {

    this.navigationRefresh();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(
        () => {
          this.navigationRefresh()
        }
      );
  }

  navigationRefresh() {
    this.routeTitle = this.getTitle(this.activatedRoute.root)
    if (this.authService.isLoggedIn()) {
      this.getMfaDetails();
      this.getClientMatterContactDetails();
    }
  }
  private getTitle(route: ActivatedRoute) : string {
    if (!route.children || route.children.length === 0) {
      return route.snapshot.data[this.ROUTE_DATA_TITLE];
    }

    for (const child of route.children){
      const title = this.getTitle(child);

      if (title !== undefined && title !== ''){
        return title;
      }
    }

    return '';
  }

  logOut() {
    this.authService.logOut();
    this.router.navigate(['/login']);
  }

  getMfaDetails(){
    this.mfaLoading = true;
    this.authService.GetMfaConfig().subscribe({
      next: totpConfig => {
        this.isMfaEnforced = totpConfig.isMfaEnforced;
        this.mfaEnabled = totpConfig.mfaEnabled;
        this.mfaLoading = false;
      }
    });
  }

  getClientMatterContactDetails() {
    this.clientService.getClientMatterContactDetails().subscribe({
      next: ClientMatterContactDetails => {
        this.clientMatterContactDetails = ClientMatterContactDetails;
      }
    });
  }

}
